"use strict";

define('uikit/elements/progress',['underscore', 'marionette', '../templates', '../mixins/component.mixin'], function (_, Mn, Templates, ComponentMixin) {
  var Progress = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui progress',
    template: Templates.UIKit['progress'],
    options: {
      percent: 0,
      transition: '300ms',
      active: false,
      text: '',
      state: '',
      showPercent: false,
      inverted: false,
      attached: false,
      size: null,
      color: null,
      disabled: false
    },
    update: {
      percent: false,
      active: false,
      showPercent: false,
      state: false,
      inverted: false,
      size: false,
      color: false,
      disabled: false
    },
    ui: {
      bar: '.bar',
      progress: '.progress'
    },
    updateAttributes: function updateAttributes() {
      this.addClass('active', this.getBoolOption('active')).addClass('disabled', this.getBoolOption('disabled')).addClass('inverted', this.getBoolOption('inverted')).addClass(this.size, this.getBoolOption('size')).addClass(this.color, this.getBoolOption('color'));
      if (this.attached) {
        if (_.isString(this.attached)) {
          this.addClass(this.attached + ' attached', true);
        } else {
          this.addClass('bottom attached', true);
        }
      }
      switch (this.state) {
        case 'success':
          this.addClass('success', true);
          break;
        case 'warning':
          this.addClass('warning', true);
          break;
        case 'error':
          this.addClass('error', true);
          break;
      }
      this.ui.bar.css('width', this.percent + '%');
      if (this.showPercent) {
        this.ui.progress.text(this.percent + '%');
      } else {
        this.ui.progress.text('');
      }
    }
  });
  return Progress;
});

